import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { type MarketableProduct } from 'dto/marketableProduct';
import { validateCalculatorForm } from 'individual/components/BackgroundInfo/EditableForm';
import { type BackgroundInfoForm } from 'individual/types/backgroundInfoForm';
import { toEditableForm } from 'state/util';
import { getValidAgeRange } from 'utils';

/**
 * Validates background information form data and navigates to the
 * background info page if the form is not valid.
 *
 * @param {BackgroundInfoForm} backgroundInfoForm
 * @param {boolean} authenticatedCustomer
 * @param {MarketableProduct} marketableProduct
 */
export const useBackgroundInfoGuard = (
  backgroundInfoForm: BackgroundInfoForm,
  authenticatedCustomer: boolean,
  marketableProduct: MarketableProduct
) => {
  const navigate = useNavigate();
  const [isValid, setIsValid] = useState<boolean>(false);
  useEffect(() => {
    const validationErrors = validateCalculatorForm(
      toEditableForm(backgroundInfoForm),
      authenticatedCustomer,
      {
        maxMonthlyIncome: marketableProduct.maxMonthlyIncome,
        maxDebt: marketableProduct.maxDebt,
        maxChildren: marketableProduct.maxChildren,
      },
      getValidAgeRange(marketableProduct)
    );
    if (validationErrors) {
      navigate('/');
    } else {
      setIsValid(true);
    }
  }, []);

  return isValid;
};
